// extracted by mini-css-extract-plugin
export default {"botao":"button_botao__MgoEN"};